import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import JobWorkerOfferWorkerDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferWorkerDeclinedReason";

export default class UpdateJobWorkerOfferWorkerAcceptanceRequest extends BaseUpdateRequest {
    jobWorkerOfferId: string;
    accepted = false;
    declinedReason: JobWorkerOfferWorkerDeclinedReason;
}